export default __webpack_public_path__ + "static/media/desk.ee71042d.jpg";